/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, {useState,useEffect} from 'react'
import 'antd/dist/antd.css'
import { Menu, Row, Col } from 'antd';
import { UserOutlined, DatabaseFilled, DollarOutlined, CreditCardOutlined, TagOutlined, StarOutlined, BellOutlined} from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import * as actionCreators from '../redux/actions'
import userIconImage from 'images/icon-memberwhite.svg'
import { clearLoginInfo } from 'redux/auth'
var first = true
const { SubMenu } = Menu;
// class for react extra component

const HomePageSideMenu = (props) => {
  const [current, setCurrent] = useState('')
  const [trigger, setTrigger] = useState(false)
  const [open, setOpen] = useState('')
  const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
  // i18n language switch
  const { t } = useTranslation()
  // const { GlobalSetting } = props.GlobalSetting
   
  // Click action control
  const handleClick = e => {
    if(e.key===current){
      window.location.reload()
    }else{
      setCurrent(e.key)
    }
  }
  useEffect(()=>{
    if(window.location.pathname.split('/')[2] === 'service'
    || window.location.pathname.split('/')[2] === 'cost'
    ){
      setCurrent(window.location.pathname.split('/')[2])
    }else if(window.location.pathname.split('/')[2] === 'account'){
      setOpen('myAccount')
      setCurrent(window.location.pathname.split('/')[3])
    }else{
      setCurrent(window.location.pathname.split('/')[2])
    }

    if(first && window.location.pathname.split('/')[2] === 'account'){
      setOpen('myAccount')
    }else{
      first = false
      if(trigger){
        setOpen('myAccount')
      }else{
        setOpen('')
      }
    }
  })
  const cnNum =(value)=>{   
    let cnChar=value.match(/[^\x00-\x80]/g);
    return cnChar ? cnChar.length : 0;
  }  
  const processName=(name)=>{
    let cnLen = cnNum(name)
    let enLen = name.length
    if(name.length>8){
      return <div className='accountName'>{name.slice(0,8)+"..."}</div>
    }
    return <div className='accountName'>{LoginInfo.userName}</div>
  }
  return (
    <>
    <div className='menulayout'>
        <Menu
          theme='dark'
          onClick={handleClick}
          style={{ width: '100%'}}
          openKeys={[open]}
          selectedKeys={[current]}
          mode='inline'
          onOpenChange={(e)=>{
            setTrigger(!trigger)
            setOpen('myAccount')
          }}
        >
          <div className='block'></div>
          <div className='profile'>
            <Row style={{ padding: '30px 0px' }}>
              <Col span={8}>
                
                <div className='image'>
                  {
                    LoginInfo.profilePhoto?
                    <img className='photo' alt='user' src={LoginInfo.profilePhoto}/>:
                    <img className='user' alt='user icon' src={userIconImage}></img>
                  }
                </div>
              </Col>
              <Col span={16} style={{ padding: '36px 5px' }}>
                {
                LoginInfo !== null ?
                <>{processName(LoginInfo.userName)}</>:
                <p className='accountName'>NULL</p>
                }
              </Col>
            </Row>
          </div>
          <SubMenu key='myAccount' icon={<UserOutlined />} title={t('Menu.my_account')}>
            {
              LoginInfo.accountType === "admin"? <Menu.Item style={{ paddingLeft:localStorage.getItem('lang')==='en'?'50px':'65px' }} key='basic'>
              <Link to='/portal/account/basic'>{t('Menu.profile')}</Link>
            </Menu.Item>:
            null
            }

            <Menu.Item style={{ paddingLeft:localStorage.getItem('lang')==='en'?'50px':'65px' }} key='setting'>
              <Link to='/portal/account/setting'>{t('Menu.manage_users')}</Link>
            </Menu.Item>
            <Menu.Item style={{ paddingLeft:localStorage.getItem('lang')==='en'?'50px':'65px' }} key='password'>
              <Link to='/portal/account/password'>{t('Menu.change_password')}</Link>
            </Menu.Item>
          </SubMenu>
          <Menu.Item style={{ paddingLeft:'35px' }} icon={<DatabaseFilled />} key='service'>
            <Link to='/portal/service'>{t('Menu.subscriptions')}</Link>
          </Menu.Item>
          <Menu.Item style={{ paddingLeft:'35px' }} key='preorder'>
            <Link to='/portal/preorder'>{t('Menu.Preorder')}</Link>
          </Menu.Item>
          {/* <Menu.Item style={{ paddingLeft:'35px' }} icon={<DollarOutlined/>} key='point'>
            <Link to='/portal/point'>{t('Menu.stored_points')}</Link>
          </Menu.Item> */}
          <Menu.Item style={{ paddingLeft:'35px' }} icon={<CreditCardOutlined />} key='cost'>
            <Link to='/portal/cost'>{t('Menu.billing')}</Link>
          </Menu.Item>
          <Menu.Item style={{ paddingLeft:'35px' }} key='contact'>
            <Link to='/portal/contact'>{t('Menu.ContactUs')}</Link>
          </Menu.Item>

          {/* <Menu.Item style={{ paddingLeft:55 }} icon={<TagOutlined />} key='ticket'>
            <Link to='/portal/ticket'>{t('Menu.vouchers')}</Link>
          </Menu.Item>
          <Menu.Item style={{ paddingLeft:55 }} icon={<StarOutlined />} key='reply'>
            <Link to='/portal/reply'>{t('Menu.my_reviews')}</Link>
          </Menu.Item>
          <Menu.Item style={{ paddingLeft:55 }} icon={<BellOutlined />} key='notice'>
            <Link to='/portal/notice'>{t('Menu.notifications')}</Link>
          </Menu.Item> */}
        {/* 底部聯絡我們 */}
        {/* <div style={{ paddingTop: '10vh'}}>
        <Row justify="space-around" align="top" style={{ padding: '20px', backgroundColor:'#71AA1F'}}>
          <Col span={6}>
            <Link to='/portal/contact'>聯絡我們</Link>
          </Col>
          <Col span={6}>
            問答紀錄
          </Col>
          <Col span={8}>
            FQA常見問題
          </Col>
        </Row>
        </div>
   */}
        </Menu>

    </div>

    </>
  )
}

// store items in props
// redux store state default
const mapStatetoProps = (store) => (
  { LoginInfo: store.LoginInfo }
)

const mapDispatchToProps = dispatch => {
  return {
    clearLoginInfo: () => {
      dispatch(clearLoginInfo())
    }
  }
}

// const mapStateToProps = store => (
//   { GlobalSetting: store.GlobalSetting }
// )
// Connect Redux store
// Store state in props
// actionCreators put actions in props
// using mapDispacthToProps
export default connect(mapStatetoProps,mapDispatchToProps,'', actionCreators)(HomePageSideMenu)
